import styled from 'styled-components';
import { v2Colors, v2FontFamily } from '../../formInputsV2/styles/tokens';

// v2 look, same markup: opted into with <OptionalDocumentModal v2 />.
export const OptionalDocumentModalV2Styles = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background: rgba(16, 24, 40, 0.5);
  font-family: ${v2FontFamily};

  .modal-dialog {
    width: 100%;
    max-width: 460px;
    margin: 0;
  }

  .modal-content {
    border: 0;
    border-radius: 20px;
    background: #fff;
    box-shadow: 0 24px 64px rgba(16, 24, 40, 0.24);
    overflow: hidden;
  }

  .modal-header {
    gap: 12px;
    padding: 18px 24px;
    border-bottom: 1px solid ${v2Colors.disabledSurface};
  }

  .modal-title {
    margin: 0;
    color: ${v2Colors.text};
    font-family: ${v2FontFamily};
    font-size: 18px !important;
    font-weight: 700;
    line-height: 1.3;
    letter-spacing: -0.01em;
  }

  .modal-header .btn-close {
    box-sizing: border-box;
    flex-shrink: 0;
    width: 32px;
    height: 32px;
    margin: 0 0 0 auto;
    padding: 0;
    border-radius: 50%;
    background-size: 12px auto;
    opacity: 0.7;
    transition: background-color 150ms ease, opacity 150ms ease;

    &:hover {
      background-color: ${v2Colors.disabledSurface};
      opacity: 1;
    }

    &:focus,
    &:focus-visible {
      outline: 0;
      opacity: 1;
      box-shadow: 0 0 0 3px ${v2Colors.primarySoftHover};
    }
  }

  .modal-body {
    padding: 20px 24px 24px;
    background: ${v2Colors.surface};
  }
`;

export const OptionalDocumentSubmit = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 44px;
  margin-top: 8px;
  padding: 11px 20px;
  border: none;
  border-radius: 12px;
  background: ${v2Colors.primary};
  color: #fff;
  font-family: ${v2FontFamily};
  font-size: 14.5px;
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  cursor: pointer;
  transition: background-color 150ms ease;

  &:hover,
  &:focus-visible {
    background: ${v2Colors.primaryHover};
  }
`;
